"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TestExtractSignalsDefinition = void 0;
const z = require("zod");
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const package_common_1 = require("../../../Datatypes/package-common");
exports.TestExtractSignalsDefinition = {
    type: 'TestExtractSignals',
    displayName: 'Test Extract Signals',
    inputSchema: z.object({
        packageName: z.string(),
        packageFamilyName: z.string(),
        datasheetUri: package_common_1.DatasheetUriSchema,
        sigmaModelType: package_common_1.SigmaModelTypeSchema,
    }),
    outputSchema: z.object({
        signals: z.array(sigma_engine_shared_1.SignalSchema),
    }),
};
//# sourceMappingURL=test-extract-signals.js.map